export default __webpack_public_path__ + "static/media/map-small.61185177.png";